import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { CreateChannel } from "../schemas/schemas_0";
export { $Command };
export class CreateChannelCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [getEndpointPlugin(config, Command.getEndpointParameterInstructions())];
})
    .s("ChimeMessagingService", "CreateChannel", {})
    .n("ChimeSDKMessagingClient", "CreateChannelCommand")
    .sc(CreateChannel)
    .build() {
}
